import Image from 'next/future/image';
import Link from 'next/link';
import { Articles } from '@lambda/commons/apis/shopify/types/storefront';
import { Paginate } from '@lambda/commons/apis/shopify/types/common';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

export default function Sidebar(props: { articles: Paginate<Articles> }) {
  dayjs.extend(advancedFormat);
  const sideBarAritcles =
    props.articles.edges.length > 5
      ? props.articles.edges.slice(2, 5)
      : props.articles.edges.slice(0, 3);

  return (
    <div className="pl-7">
      <h2 className="mb-5 text-lg font-bold text-gray-700 md:text-2xl">
        Popular posts
      </h2>
      <ul className="list-none">
        {sideBarAritcles.map((a, i) => (
          <li className="relative mb-6 flex" key={a.node.handle}>
            <span className="absolute top-[50%] -left-4 z-10 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full border-[2px] border-white bg-blue-500 text-sm text-white">
              {i + 1}
            </span>
            {a.node?.image?.url && (
              <Link href={`/blogs/${a.node.handle}`} passHref>
                <a>
                  <span className="flex w-[100px]">
                    <Image
                      src={a.node.image.url}
                      alt="popular1"
                      className="w-full object-contain duration-1000 ease-in-out hover:scale-[1.07]"
                      width={100}
                      height={80}
                    />
                  </span>
                </a>
              </Link>
            )}

            <div className="pl-5">
              <Link href={`/blogs/${a.node.handle}`} passHref>
                <a>
                  <h4 className="mb-2 text-sm font-semibold text-gray-700 duration-500 ease-in-out hover:text-blue-500">
                    {a.node.title}
                  </h4>
                </a>
              </Link>
              <p className="text-sm">
                {a.node.tags.length > 0 && (
                  <>
                    <span>{a.node.tags[0]}</span>
                    <span className="mx-2.5 inline-block h-1.5 w-1.5 rounded-full bg-gray-700"></span>
                  </>
                )}
                <span>{dayjs(a.node.publishedAt).format('MMM Do YYYY')}</span>
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
